import Vue from 'vue'

const Console = {
  methods: {
    logConsole: obj => {
      if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'pmiproduction') {
        console.log(obj)
      }
    }
  }
}

Vue.mixin(Console)
